'use client';

import { TableHeadline } from '..';
import { ResultsTable } from '../../..';
import { usePrizeTablesContext } from '../../context';

/**
 * PrizeTablesList component renders a list of prize tables for a lottery one after another,
 * with appropriate TableHeadline and ResultsTable components.
 * @returns set of HTMLDivElements with TableHeadline and ResultsTable components in each.
 */
function PrizeTablesList() {
  const { lotteryName, drawingDate, extraGames, tables, className } = usePrizeTablesContext();
  return tables.map(({ lotteryId, data }) => (
    <div key={lotteryId} className={className} data-track-product={lotteryId}>
      <TableHeadline lotteryName={lotteryName} isPrimaryTable={lotteryId === lotteryName} extraGameId={lotteryId!} drawingDate={drawingDate} extraGames={extraGames} />
      <ResultsTable data={data} />
    </div>
  ));
}

export { PrizeTablesList };
